<section class="component-wrapper">

    <p class="title">{{ 'TITLE' | translate }}</p>
    <section class="video-wrapper">
        <img style='margin: auto; display: block; width: 100%; 'class='vidyard-player-embed'
        src='https://play.vidyard.com/kwofrcHUPvorVfA1zwJcXd.jpg'
        data-width='auto'
        data-controller='hubs'
        data-action='show'
        data-uuid='kwofrcHUPvorVfA1zwJcXd'
        data-type='inline'
        data-hidden_controls="1"
        data-viral_sharing="0"
        data-autoplay="1" />
    </section>
    <section class="check-terms-conditions">
        <input #acceptTermsConditionsEl type="checkbox" (change)="updateCheckboxStatus(acceptTermsConditionsEl.checked)">
        <span>I accept <a href="https://www.mitel.com/en-ca/legal/mitel-cloud-services-terms-and-conditions"
            target="_blank" rel="noopener noreferrer">{{ 'TERMS_AND_CONDITIONS' | translate }}</a>
            {{ 'TERMS_AND_CONDITIONS_MESSAGE_START' | translate}}
            <a href="https://oneview.mitel.com/s/article/MiCloud-Connect-for-Microsoft-Teams-Overview" target="_blank" rel="noopener noreferrer">{{ 'TERMS_AND_CONDITIONS_MESSAGE_REF_LINK_MESSAGE' | translate}}</a>
            {{ 'TERMS_AND_CONDITIONS_MESSAGE_END' | translate}}
            </span>
    </section>
    <section class="buttons-panel">
        <button (click)="sendActivationCancel()"><fa-icon class="cancel-icon" [icon]="fontAwesomeBanIcon"></fa-icon>Cancel</button>
        <button class="btn-ok" [disabled]="!(this.termsConditionsChecked && this.videoEnded)"
            (click)="sendActivationSuccess()">OK</button>
    </section>
</section>

